<template>
  <transition name="fade-bottom">
    <div v-if="showCookiesBar" class="cookies-bar" :style="{ background: primaryColor }">
      <div class="message">
        <p :style="{ color: secondaryColor }">This website uses cookies and similar technologies to give you a better experience</p>
      </div>

      <div class="buttons">
        <!-- data-bs-toggle="modal" data-bs-target="#modal-cookies" -->
        <button type="button" @click="$root.showModal('modal-cookies')" :style="{ color: secondaryColor, borderColor: secondaryColor }">CHANGE SETTINGS</button>
        <button type="button" @click="acceptAll" :style="{ color: secondaryColor, borderColor: secondaryColor }">OK I CONFIRM</button>
      </div>
    </div>
  </transition>

  <teleport to="#teleport-modals">
    <div id="modal-cookies" class="modal modal-pattern fade" tabindex="-1" aria-labelledby="modal-cookies-label" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-header">
        <!-- <img src="{{ root_site_asset('images/logo.png') }}" class="modal-logo" alt="The Athenian House"> -->

        <!-- <button type="button" class="btn-modal-close" @click="dscardSettings()" data-bs-dismiss="modal" aria-label="Cancel">
          <i class="icon-close"></i>
        </button> -->

        <!-- <button type="button" class="btn-discard-cookies" data-bs-dismiss="modal" aria-label="Close">
            <i class="icon-close"></i>
            <span>CANCEL</span>
          </button> -->
      </div>

      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row pt-lg-8 px-lg-8 px-4">
              <div class="col-16">

                <p class="cookies-title mb-7">Cookies</p>
                
                <!-- 
                  Necessary: {{ cookies.necessary }}<br>
                  Statistics: {{ cookies.statistics }}<br>
                  Marketing: {{ cookies.marketing }}<br>
                -->
                
                <button type="button" class="btn-accept-decline accept" disabled>
                  <div class="btn-accept-decline-switch">
                    <span class="switch-label switch-label-left">on</span>
                    <span class="switch-label switch-label-right">off</span>
                  </div>

                  <div class="descr">
                    <p class="descr-title">Strictly necessary and performance cookies</p>
                    <p class="descr-text">These cookies remember choices you make to improve your experience. This information is not used for advertising on other sites.</p>
                  </div>
                </button>

                <!-- Statistics -->
                <button type="button" class="btn-accept-decline" :class="{ 'accept': cookies.statistics, 'decline': !cookies.statistics }" @click="cookies.statistics = !cookies.statistics">
                  <div class="btn-accept-decline-switch">
                    <span class="switch-label switch-label-left">on</span>
                    <span class="switch-label switch-label-right">off</span>
                  </div>

                  <div class="descr">
                    <p class="descr-title">Functional and targeting cookies</p>
                    <p class="descr-text">These cookies share information about your browsing habits with 3rd parties to help make advertising relevant to you and your interests.</p>
                  </div>
                </button>
                <!-- Statistics END-->

                <!-- Marketing (NOT PRESENT NOW) -->
                <!-- <button type="button" class="btn-accept-decline" :class="{ 'accept': cookies.marketing, 'decline': !cookies.marketing }" @click="cookies.marketing = !cookies.marketing">
                  <div class="btn-accept-decline-switch">
                    <span class="switch-label switch-label-left">on</span>
                    <span class="switch-label switch-label-right">off</span>
                  </div>

                  <div class="descr">
                    <p class="descr-title">Marketing</p>
                    <p class="descr-text">Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.</p>
                  </div>
                </button> -->
                <!-- Marketing (NOT PRESENT NOW) END-->
              </div>
              

              <div class="col-16 text-center mt-sm-5">
                <button type="button" class="btn-save-cookies" :style="{ background: primaryColor, color: secondaryColor }" data-bs-dismiss="modal" @click="sendCookiesSelection()">save <span>&</span> close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>

const _getCsrfTokenUrl = '/'+window.Laravel.code+'/get/csrf';
const _setCookiesPref = '/'+window.Laravel.code+'/setcookies/pref';
import axios from 'axios'
export default {
  props: {
    primaryColor: {
      type: String,
      required: false,
      default: "#000"
    },
    secondaryColor: {
      type: String,
      required: false,
      default: "#fff"
    },
    cookiesopt:{
      type: Object,
      required: true,
      default: () => ({
        necessary: true,
        statistics: false,
        marketing: false
      })
    }
  },
  data() {
    return {
      showCookiesBar: this.frequencyCookieExpired(),
      cookies: this.cookiesopt,
    }
  },
  methods: {
    acceptAll(){
      const component = this;
      component.cookies = {
        necessary: true,
        statistics: true,
        marketing: true
      };
      this.sendCookiesSelection();
    },
    sendCookiesSelection(){
      const component = this;
      axios.get(_getCsrfTokenUrl)
          .then(response => {
            var _token = response.data._token;
            axios.defaults.headers.common = { 'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': _token };
            axios
              .post(_setCookiesPref, component.cookies)
              .then(function (success) {
                try {
                    gtag('consent', 'update', {
                      // standard
                      'functionality_storage': component.cookies.necessary? 'granted' : 'denied',

                      // Analytics
                      'analytics_storage': component.cookies.statistics?'granted':'denied',

                      // Ads
                      'ad_storage': component.cookies.marketing?'granted':'denied',
                      'ad_user_data': component.cookies.marketing?'granted':'denied',
                      'ad_personalization': component.cookies.marketing?'granted':'denied',
                      'personalization_storage': component.cookies.marketing?'granted':'denied',
                      'security_storage': component.cookies.marketing?'granted':'denied',
                  });
                } catch (error) {
                  
                }
                
                component.closeCookiesBar();
                },function (error) {
                  console.log(error);
              });
          })
          .catch(error => {
            console.error(error);
          });
    },
    getFrequencyCookie() {
      let cookie;
      const cookies = `; ${document.cookie}`;
      const parts = cookies.split(`; showCookiesBar=`);

      if (parts.length === 2) {
        cookie = parts.pop().split(';').shift();
      }

      return cookie;
    },
    setFrequencyCookie(value, days = 30) {
      const today = new Date();
      const expireDate = new Date(today.setDate(today.getDate() + days));
      document.cookie = `showCookiesBar=false; expires=${expireDate}`;
    },
    frequencyCookieExpired() {
      return (this.getFrequencyCookie() == null || this.getFrequencyCookie() === true)
    },
    closeCookiesBar() {
      this.showCookiesBar = false;
      this.setFrequencyCookie(true);
    },
  },
}
</script>

<style lang="scss">
.fade-bottom-enter-active,
.fade-bottom-leave-active {
  transition: opacity 250ms ease-in-out, transform 250ms ease-in-out;
}

.fade-bottom-enter,
.fade-bottom-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.cookies-bar {
  position: fixed;
  bottom: 67px;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 15px 10px;
  z-index: 1000;
  box-shadow: 0px -10px 20px rgba(#000, 0.3);

  .message {
    p {
      font-size: 0.56rem;
      letter-spacing: 0.025rem;
      font-weight: 300;
      text-align: center;
    }
  }

  .buttons {
    margin: 10px 15px 0px;
    text-align: center;

    button {
      border-width: 1px;
      border-style: solid;
      font-size: 0.725rem;
      padding: 10px 15px;
      line-height: 1;
      margin: 5px 0.5rem;
    }
  }
}

.cookies-title {
  text-align: center;
  font-size: 30px;
  font-family: Cotta, sans-serif;
  color: #544020;
}

.btn-accept-decline {
  position: relative;
  display: flex;
  align-items: center;
  flex-flow: column;
  margin-bottom: 60px;

  .btn-accept-decline-switch {
    position: relative;
    border: 1px solid #544020;
    border-radius: 34px;
    transition: 400ms;
    display: flex;
    align-items: center;

    &::before {
      position: absolute;
      content: "";
      left: 0%;
      top: 50%;
      transform: translateY(-50%);
      width: 50%;
      height: 100%;
      background-color: #544020;
      border-radius: 34px;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      transition: left 250ms ease-in-out;
    }

    .switch-label {
      padding: 8px 5px;
      width: 70px;
      font-size: 15px;
      color: #544020;
      text-align: center;
      font-family: Cotta, sans-serif;
      position: relative;
      transition: color 250ms ease-in-out;
    }
  }

  &.accept {
    .btn-accept-decline-switch {
      .switch-label:nth-child(1) {
        color: #fff;
      }
    }
  }

  &.decline {
    .btn-accept-decline-switch {
      &::before {
        left: 50%;
      }
    }

    .btn-accept-decline-switch {
      .switch-label:nth-child(2) {
        color: #fff;
      }
    }
  }

  // &:disabled {
  //   .btn-accept-decline-switch {
  //     &::before {
  //       background-color: #9a9285;
  //     }
  //   }
  // }

  // &:hover:not([disabled]) {
  //   .btn-accept-decline-switch {
  //     opacity: 0.7;
  //   }
  // }

  .descr {
    margin-top: 20px;
    text-align: center;
    color: #544020;

    .descr-title {
      font-family: Cotta, sans-serif;
      line-height: 1.5;
      font-size: 18px;
    }

    .descr-text {
      margin-top: 5px;
      line-height: 1.5;
      font-size: 12px;
    }
  }

  &:disabled {
    color: #000;
  }
}

.btn-discard-cookies {
  text-align: center;

  i {
    color: #000;

    &::before {
      font-size: 40px;
    }
  }

  span {
    display: block;
    color: #000;
    letter-spacing: 0.025rem;
    line-height: 1;
    font-size: 0.75rem;
  }
}

.btn-save-cookies {
  font-size: 0.9375rem;
  font-weight: 400;
  padding: 18px 54px;
  border-radius: 50px;
  font-family: Cotta, sans-serif;
  transition: opacity 250ms ease-in-out;

  span {
    font-family: NT Seawave, sans-serif;
  }

  &:hover {
    background: transparent;
    opacity: 0.6;
  }
}

@media only screen and (min-width: 700px) {
  .cookies-bar {
    bottom: 0px;
  }

  .btn-accept-decline {
    flex-flow: row;

    .descr {
      margin-top: 0px;
      margin-left: 20px;
      text-align: left;
    }
  }
}

@media only screen and (min-width: 1200px) {
  .cookies-bar {
    box-shadow: 0px 0px 20px rgba(#000, 0.3);
    background-color: #dbeae7 !important;
    right: unset;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
    max-width: 450px;
    padding: 20px;

    .message {
      p {
        color: #544020 !important;
      }
    }

    .buttons {
      button {
        border-radius: 20px;
        color: #544020 !important;
        border-color: #544020 !important;
      }
    }

  }
}
</style>